import React from "react";
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Table from 'react-bootstrap/Table';
import Badge from 'react-bootstrap/Badge';
import CancelRequest from "../../magData/Train/CancelRequest";
import CancelResponse from "../../magData/Train/CancelResponse";

function TrainCancelPage(props) {

  return (
    <>

      <Container fluid >
        <Row>
          <Col sm={12} >
            <p className="page-title">Train Cancel Method</p>
          </Col>
          <Col sm={12} >
            <p>EndPoint : https://gdscpapi.parsgds.com/gateway/Train/cancel</p>
          </Col>
          <Col sm={12} >
            <p> type : json (default)</p>
          </Col>
        </Row>
        <Row>
          <Col sm={12} >
            <p>Body Parameters</p>
          </Col>
        </Row>
        <Row>
          <Col sm={12}><span className="code-section-title">Request Formats - application/json, text/json</span></Col>
          <Col sm={12}>

            <pre className="code-section">
              {JSON.stringify(CancelRequest, null, 2)}
            </pre>
          </Col>
        </Row>
        {/* Response  */}
        <Row>
          <Col sm={12} >
            <p>Response Information</p>
          </Col>
        </Row>
        <Row>
          <Col sm={12}><span className="code-section-title">Response Formats - application/json, text/json</span></Col>
          <Col sm={12}>
            <pre className="code-section">
              {JSON.stringify(CancelResponse, null, 2)}
            </pre>
          </Col>
        </Row>
      </Container>

    </>
  );
}

export default TrainCancelPage;